import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {

  admin_totalEntities({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      axios.get(Config.apiPath + 'admin/total/entities')
        .then(
          response => {
            resolve(response.data);
          })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  
  admin_auto_jobs({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      axios.get(Config.apiPath + 'admin/auto-jobs')
        .then(
          response => {
            resolve(response.data);
          })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
};

const mutations = {};

export default {
  state,
  actions,
  mutations
};
